module.exports = __webpack_public_path__ + "img/top.6bf4f9d5.jpg";